export default __webpack_public_path__ + "static/media/invoiceIcon.31734ccf.svg";